var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bg-gray-lighten3 py-12",attrs:{"id":_vm.data.id}},[_c('div',{staticClass:"container"},[(_setup.items)?_c('UiPackery',{attrs:{"cols":_setup.grid.cols,"rows":_setup.grid.rows}},_vm._l((_setup.items),function(item,i){return _c('UiPackeryItem',{key:i,staticClass:"group",class:[
          _setup.grid.colSpan[_setup.isWide(i) ? 2 : item.width],
          _setup.grid.rowSpan[item.height],
        ]},[_c(_setup.CatalogCategoryItem,_vm._b({staticClass:"p-6 md:p-4 lg:p-6"},'CatalogCategoryItem',item,false))],1)}),1):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }